import Sidebar from '../../components/Sidebar/Sidebar';
import Header from '../../components/Header/Header';
import { Controller, useForm } from 'react-hook-form';
import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { deleteAccount } from '../../services/operations/auth';
const DeleteAccount = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false)
    const { handleSubmit, setValue, control, formState: { errors } } = useForm({
        mode: 'all',
        defaultValues: {
            email: ''
        }
    });
    const dispatch = useDispatch()

    const onSubmit = (data) => {
        const { email } = data
        dispatch(deleteAccount(email))
        setValue('email', '')
    };
    return (
        <div className="flex dark:bg-dark font-primary h-screen overflow-hidden bg-[#fafafa]">
            <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
                <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                <main>
                    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
                        <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-y-4 mt-4">
                            <div className="flex flex-col gap-y-2">
                                <div className="flex items-center gap-x-4">
                                    <label className="text-gray-800 dark:text-zinc-300 text-[16px] font-medium">
                                        Email<span className="text-red-500">*</span>
                                    </label>
                                    {errors?.email && (
                                        <span className="text-red-500">{errors.email.message}</span>
                                    )}
                                </div>
                                <Controller
                                    name="email"
                                    control={control}
                                    render={({ field }) => (
                                        <input
                                            {...field}
                                            type="email"
                                            className="form-input w-full"
                                            placeholder="Enter email"
                                        />
                                    )}
                                />
                            </div>
                            {/* Submit Button */}
                            <div className="mt-4">
                                <button type="submit" className="btn btn-primary">Submit</button>
                            </div>
                        </form>
                    </div>
                </main>
            </div>
        </div>
    )
}

export default DeleteAccount